"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAccount = exports.createPassword = exports.setPassword = exports.createAccount = void 0;
function createAccount(client, opts) {
    return client.post('create_account', opts.account);
}
exports.createAccount = createAccount;
function setPassword(client, opts) {
    return client.post('set_password', {
        current_password: opts.currentPassword,
        new_password: opts.newPassword
    });
}
exports.setPassword = setPassword;
function createPassword(client, opts) {
    return client.post('create_password', {
        password: opts.password
    });
}
exports.createPassword = createPassword;
function setAccount(client, opts) {
    return client.post('set_account', opts.account);
}
exports.setAccount = setAccount;
